export default "__VITE_ASSET__317a297c__"